import type React from 'react';

import { Alert } from '@change/ds-core-ui';

import { useVideosComponentContext } from '../../context';

export const ErrorMessage: React.FC = () => {
	const {
		data: { errorMessage },
	} = useVideosComponentContext();

	return (
		<Alert heading="Error" data-testid="video-upload-error" variant="error">
			{errorMessage}
		</Alert>
	);
};
